<template>
</template>

<script>
    import Errors from '@/api/types/errors'

    export default {
      methods: {
        async saveForm() {
          if (this.$v) {
            this.$v.$touch();
            if (this.$v.$invalid) {
              return;
            }
          }

          this.runBlockerAction(async () => {
            try {
              await this.$store.dispatch('saveRetend', this.retend);
            }
            catch(e) {
              let error;
              let label;
              if (!e instanceof Errors) {
                error = new Errors(Errors.UNKNOWN);
                label = error.label;
              }
              else if (e.ACCESS_DENIED) {
                label = 'errors.retend.auto-save.access-denied';
              }
              else if (e.INVALID_DATA) {
                label = 'errors.retend.auto-save.cannot-update-data';
              }
              else {
                label = e.label;
              }
              this.showError({
                error: label
              })
            }
          });
        }
      }
    }
</script>

<style scoped>

</style>
